import { getIn, useFormikContext } from "formik";
import * as React from "react";
import PasswordInput from "../Editors/PasswordInput";
import { FormGroup } from 'reactstrap';
import { FormLabel } from './FormLabel';
import ErrorMessage from "./ErrorMessage";


const PasswordFormInput = ({ id, label })=>{

    const { setFieldValue, values } = useFormikContext();
    const value = getIn(values, id);

    const changed = (e) => {

        setFieldValue(id, e.target.value);
    };
    return <FormGroup>
        {label ? <FormLabel htmlFor={id} style={{ display: 'block' }}>{label}</FormLabel> : null}
        <ErrorMessage name={id} />
        <PasswordInput onChange={changed} value={value} />
    </FormGroup>
}

export default PasswordFormInput;